import { useState } from "react";
import WoSectionCard from "../common/WoSectionCard";
import Pos from "./Pos";

// Purchase Orders section as an independent card matching the proposals/forms look.
function WoPos({ woId, refreshToken, navigatePODetail, poEditHandle, onPreviewAttachments }) {
  const [count, setCount] = useState(0);

  return (
    <WoSectionCard title="Purchase Orders" count={count} tour="wo-sec-pos">
      <Pos
        woId={woId}
        refreshToken={refreshToken}
        navigatePODetail={navigatePODetail}
        poEditHandle={poEditHandle}
        onPreviewAttachments={onPreviewAttachments}
        onCount={setCount}
      />
    </WoSectionCard>
  );
}

export default WoPos;
